import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    groupTree: []
  },
  mutations: {
    setGroupTree(state, data) {
      state.groupTree = data
    }
  },
  actions: {
  },
  modules: {
  }
})
